import { Component, EventEmitter, OnInit } from '@angular/core';
import { MobileDetectorService } from '@services/MobileDetectorService/mobile-detector.service';
import { BottomDrawerManageService } from '../bottom-drawer/bottom-drawer-manage.service';

@Component({
  selector: 'app-adaptive-context-menu',
  templateUrl: './adaptive-context-menu.component.html',
  styleUrls: ['./adaptive-context-menu.component.scss'],
})
export class AdaptiveContextMenuComponent  implements OnInit {
  
  public showModal: EventEmitter<boolean> = new EventEmitter(false);

  private stackLengthOnOpen: number = 0;

  constructor(
    public mobileDetector: MobileDetectorService,
    private bottomDrawer: BottomDrawerManageService,
  ) { }

  public ngOnInit() {

    
  }

  public openModal() {
    this.showModal.next(true);
    this.stackLengthOnOpen = this.bottomDrawer.drawersStackLength;
  }

  public onContentClick() {
    if (this.stackLengthOnOpen >= this.bottomDrawer.drawersStackLength)
      this.showModal.next(false);
  }
}
